
import vFooter from '../common/footer.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import {reg , login,send_code} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
padShow: false,
loginShow:true,
toggleText: '手机验证码登录',
isAgree:false,
loginToggle: false,
isTime: true,
inputChange:false,
time: 60,
accessToken:'',
securitys: '',
realname:'',
phone:'',
smsCode:'',
pwd:'',
loginWay:'pwd',
isReg:false
}
},
created(){

this._wxTool.auth();
this._wxTool.setNoShare();
if(null!=this._wxTool.getMember()){//已经注册的用户不能进入当前页面
this.$router.push('/my');
}

},
components: {
vFooter
},
methods: {
padShows() {
this.padShow = !this.padShow
},
loginShows() {
this.loginShow = !this.loginShow
this.realname=''
this.phone=''
this.smsCode=''
this.pwd=''
},
agree(){
this.isAgree = !this.isAgree
},
loginToggles() {
this.loginToggle = !this.loginToggle
if (this.toggleText == '手机验证码登录') {
this.toggleText = '账号密码登录'
this.loginWay = 'sms'
} else {
this.toggleText = '手机验证码登录'
this.loginWay = 'pwd'
}
this.smsCode =''
},
regProtocol(){
this.$router.push('/regProtocol')
},
security() {
if (this.isTime) {
let phone = parseInt(this.phone)
this.utils.countDown(this)
if(!this.$TelText(phone)){
this.$vux.toast.text('手机号码有误', 'middle')
return
}
let param = {
accessToken:this._wxTool.getAccessToken(),
phone:this.phone,
length:4
}
this.isTime = false
send_code(param).then(res=>{
if(res.code == 0){
console.log(res);
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
}
},
login(){
let param = {
accessToken:this._wxTool.getAccessToken(),
loginWay:this.loginWay,
phone:this.phone,
pwd:this.pwd
};




if(!this.$TelText(this.phone)){
this.$vux.toast.text('请输入正确的手机号','middle')
return
}
if(this.pwd==''){
this.$vux.toast.text('请输入密码','middle')
return
}
login(param).then(res=>{
if(res.code == 0){
console.log(res);
this.$vux.toast.text('登陆成功', 'middle')
this.$router.push('/')
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
},
smsLogin(){




if(!this.$TelText(this.phone)){
this.$vux.toast.text('请输入正确的手机号','middle')
return
}
if(this.smsCode==''){
this.$vux.toast.text('请输入验证码','middle')
return
}
let param = {
accessToken:this._wxTool.getAccessToken(),
loginWay:this.loginWay,
phone:this.phone,
smsCode:this.smsCode,
};
login(param).then(res=>{
if(res.code == 0){
this.$vux.toast.text('登陆成功', 'middle')
console.log(res)
this.$router.push('/')
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
},
reg(){





var  u = this._wxTool.getUser();
if(this.realname==''){
this.$vux.toast.text('请输入用户名','middle')
return false
}
if(!this.$TelText(this.phone)){
this.$vux.toast.text('请输入正确的手机号','middle')
return false
}
if(this.smsCode==''){
this.$vux.toast.text('请输入验证码','middle')
return
}
if(this.pwd==''){
this.$vux.toast.text('请输入密码','middle')
return false
}
if(this.pwd.length>20||this.pwd.length<6){
this.$vux.toast.text('密码格式不对','middle')
return
}
if(!this.isAgree){
this.$vux.toast.text('请勾选宇通推广大使注册协议','middle')
return false
}
var regType = this.$route.query.regType;
if(regType == null || regType == undefined || regType == 'undefined' || regType == ''){
regType = 'weixin';
}
this.$vux.loading.show({
text: '正在注册······请稍等'
});
if(this.isReg){
this.$vux.toast.text('您的操作太频繁了!','middle')
setTimeout(function(){
this.isReg = false;
},2000)
return false;
}
this.isReg = true;
let param = {
accessToken:this._wxTool.getAccessToken(),
realname:this.realname,
phone:this.phone,
smsCode:this.smsCode,
pwd:this.pwd,
regType:regType
};
reg(param).then(res=>{
this.isReg = false;
this.$vux.loading.hide();
if(res.code == 0){
console.log(res)
this.$vux.toast.text('注册成功，感谢您的支持', 'middle')
this.$router.push('/my');
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})


}
}
}



// WEBPACK FOOTER //
// ./src/pages/login/login.vue